import { S as Swiper } from './swiper-core-CZxReCTq.js';
import { N as Navigation } from './navigation-CO71jf7y.js';
import { P as Pagination } from './pagination-C0tMDIMY.js';
import './create-element-if-not-defined-2GaAVph8.js';

/**
 * Custom element for displaying recommended products as a Swiper carousel.
 * Fetches recommended products and initializes Swiper slider.
 */
class RecommendedProducts extends HTMLElement {
  /**
   * Lifecycle method called when the element is added to the DOM.
   */
  connectedCallback() {
    this.init();
  }

  /**
   * Remove loaders from product cards after content is loaded.
   *
   * @returns {void}
   */
  removeLoaders() {
    // A small timeout is used to ensure the innerHTML operation has completed to ensure the animation works.
    setTimeout(() => {
      this.querySelectorAll('[data-loader]').forEach((loader) => {
        loader.ariaHidden = true;
      });
    }, 50);
  }

  /**
   * Fetch and render recommended products, then initialize Swiper.
   */
  init() {
    if (this.dataset && this.dataset.url)
      try {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('[data-recommended-products]').innerHTML;

            this.innerHTML = html;
            this.removeLoaders();
            this.initSwiper();
          });
      } catch (error) {
        console.error(error);
        // Fallback to the original products loaded in the liquid
        this.removeLoaders();
      }
  }

  /**
   * Get navigation configuration for Swiper.
   * @param {Element} swiperEl
   * @returns {Object}
   */
  getNavigationConfig(swiperEl) {
    const nextBtn = swiperEl ? swiperEl.querySelector('.swiper-button-next') : null;
    const prevBtn = swiperEl ? swiperEl.querySelector('.swiper-button-prev') : null;
    return {
      nextEl: nextBtn,
      prevEl: prevBtn,
    };
  }

  /**
   * Get pagination configuration for Swiper.
   * @param {Element} swiperEl
   * @returns {Object}
   */
  getPaginationConfig(swiperEl) {
    return {
      el: swiperEl ? swiperEl.querySelector('.swiper-pagination') : null,
      clickable: true,
    };
  }

  /**
   * Initialize Swiper for recommended products.
   */
  initSwiper() {
    const swiperEl = this.querySelector('.swiper--recommended');
    const showPagination = swiperEl?.dataset.showPagination === 'true';
    const showNavigation = swiperEl?.dataset.showNavigation === 'true';
    const loop = swiperEl?.dataset.loop === 'true';
    if (!swiperEl) {
      return;
    }

    const navigation = this.getNavigationConfig(swiperEl);
    const pagination = this.getPaginationConfig(swiperEl);

    new Swiper('.swiper--recommended', {
      modules: [Navigation, Pagination],
      spaceBetween: 16,
      slidesPerView: 1.2,
      watchOverflow: true,
      pagination: showPagination ? pagination : false,
      navigation: showNavigation ? navigation : false,
      loop,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }
}

customElements.define('recommended-products', RecommendedProducts);
